import { render, staticRenderFns } from "./IgnoredRowsSummary.vue?vue&type=template&id=351eba58&scoped=true&"
import script from "./IgnoredRowsSummary.vue?vue&type=script&lang=js&"
export * from "./IgnoredRowsSummary.vue?vue&type=script&lang=js&"
import style0 from "./IgnoredRowsSummary.vue?vue&type=style&index=0&id=351eba58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351eba58",
  null
  
)

export default component.exports